import React from 'react';
import { RefillCheckupContext } from './RefillCheckupContext';

export const useRefillCheckup = () => {
  const context = React.useContext(RefillCheckupContext);
  if (context === undefined) {
    throw new Error(
      'useRefillCheckup must be used within a RefillCheckupProvider',
    );
  }
  return context;
};
